export default "__VITE_ASSET__295bdfdb__"